var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSeeall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.3789C20 15.9018 15.5228 20.3789 10 20.3789C4.47715 20.3789 0 15.9018 0 10.3789C0 4.85606 4.47715 0.378906 10 0.378906C15.5228 0.378906 20 4.85606 20 10.3789Z",
    fill: "#FBCD44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3536 6.11231L14.6201 10.3789L9.91877 15.0803L9.21166 14.3732L12.7059 10.8789H0V9.87891H12.7059L9.64645 6.81942L10.3536 6.11231Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSeeall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/seeall.e053fd0955502cffe1238fdcc129b206.svg";